





































































































































































































import moment from "moment";
import { Mixins } from "vue-mixin-decorator";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IPagination, ISelectItem } from "@/types";
import { ICategoryListRequest } from "@/types/category";
import { IAdminCostListRequest, ICost } from "@/types/cost";
import { ICostIndexListRequest } from "@/types/cost_index";
import { IPartnerListRequest } from "@/types/partner";
import Search from "@/components/admin/forms/Search.vue";
import GeneralMixin from "@/mixin";
import { Cost } from "@/models/cost";
import { ISite } from "@/types/site";

@Component({
  components: { Search }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("category/adminGetList")
  public adminGetCategoryList!: (params: ICategoryListRequest) => void;

  @Action("cost/adminGetList")
  public adminGetList!: (params: IAdminCostListRequest) => void;

  @Action("cost_index/adminGetList")
  public adminGetCostIndexList!: (params: ICostIndexListRequest) => void;

  @Action("csv/costExport")
  public costExport!: (params: IAdminCostListRequest) => void;

  @Action("partner/adminGetList")
  public adminGetPartnerList!: (params: IPartnerListRequest) => void;

  @Action("cost/adminAmount")
  public adminGetAmount!: (params: IPartnerListRequest) => number;

  @Action("cost/verificationCost")
  public verificationCost!: (id: number) => Promise<boolean>;

  @Getter("category/selectItem")
  public categories!: ISelectItem[];

  @Getter("partner/selectItem")
  public partners!: ISelectItem[];

  @Getter("cost_index/selectItem")
  public cost_indices!: ISelectItem[];

  @Getter("cost/pagination")
  public pagination!: IPagination<ICost[]>;

  @Getter("cost/list")
  public list!: ICost[];

  @Getter("cost/amount")
  public amount!: number;

  @Getter("cost/volume")
  public volume!: number;

  @Mutation("cost/clear")
  public clear!: () => void;

  @Prop({ default: 0 })
  public fixed_site_id!: number;

  @Watch("$route.query")
  public async changeQuery() {
    this.queryToParams();
    this.adminGetList(this.params);
    this.adminGetAmount(this.params);
  }

  //
  // variables
  //
  public site_id = 0;
  public site_name: string | null = null;

  public menu = {
    start: false,
    end: false
  };
  public dialog = false;

  public headers = [
    { text: "発生日", value: "accounted_at", sortable: false },
    { text: "外注先", value: "partner.name", sortable: false },
    { text: "カテゴリ名", value: "category.name", sortable: false },
    { text: "内容", value: "cost_index.name", sortable: false },
    { text: "合計", value: "amount", sortable: false },
    { text: "数量", value: "volume", sortable: false },
    { text: "単位", sortable: false, value: "unit" },
    { text: "メモ", value: "memo", sortable: false }
  ];

  public params: IAdminCostListRequest = {
    site_id: 0,
    start_date: "",
    end_date: "",
    category_list: [],
    partner_list: [],
    cost_index_list: [],
    per_page: 50,
    page: 1
  };

  public selectedCost: ICost = new Cost();

  //
  // methods
  //
  //--------
  // 作成時に実行
  public async created() {
    this.site_id = Number(this.$route.params.site_id);
    this.clear();
    this.queryToParams();

    if (!this.fixed_site_id) {
      this.headers.push({
        text: "現場名",
        value: "site.name",
        sortable: false
      });
    }

    this.headers.push(
      { text: "編集", sortable: false, value: "" },
      { text: "照合", sortable: false, value: "" }
    );

    await Promise.all([
      this.adminGetList(this.params),
      this.adminGetAmount(this.params),
      this.adminGetCategoryList({ per_page: 0 }),
      this.adminGetPartnerList({ per_page: 0 }),
      this.adminGetCostIndexList({ per_page: 0 })
    ]);
  }

  // urlからパラメータをセットする
  // $router -> params
  private queryToParams() {
    const query = this.$route.query;
    // 配列の場合はそのまま、そうでない場合は配列に変換、nullは除外
    const category_list = query.category_list
      ? (Array.isArray(query.category_list)
          ? query.category_list
          : [query.category_list]
        )
          .filter((item): item is string => item !== null) // nullを除外する
          .map(Number)
      : [];

    const partner_list = query.partner_list
      ? (Array.isArray(query.partner_list)
          ? query.partner_list
          : [query.partner_list]
        )
          .filter((item): item is string => item !== null) // nullを除外する
          .map(Number)
      : [];

    const cost_index_list = query.cost_index_list
      ? (Array.isArray(query.cost_index_list)
          ? query.cost_index_list
          : [query.cost_index_list]
        )
          .filter((item): item is string => item !== null) // nullを除外する
          .map(Number)
      : [];

    this.params = {
      site_id: this.fixed_site_id || 0,
      start_date: query.start_date ? decodeURI(query.start_date as string) : "",
      end_date: query.end_date ? decodeURI(query.end_date as string) : "",
      category_list: category_list,
      partner_list: partner_list,
      cost_index_list: cost_index_list,
      page: query.page ? Number(query.page) : 1
    };
  }

  // 1ページ目から検索
  // 主に検索条件が変更されたときに利用
  public async searchFirst() {
    this.params.page = 1;
    await this.paramsToQuery();
  }

  // URLのパラメータをセットする
  // params -> $router
  private paramsToQuery() {
    this.$router
      .push({
        path: this.$router.currentRoute.path,
        query: {
          start_date: this.params.start_date,
          end_date: this.params.end_date,
          site_id: this.params.site_id ? String(this.params.site_id) : "",
          category_list: this.params.category_list?.map(String),
          partner_list: this.params.partner_list?.map(String),
          cost_index_list: this.params.cost_index_list?.map(String),
          page: this.params.page ? String(this.params.page) : "1"
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});
  }

  public rowClick(cost: ICost) {
    this.$router.push(`/admin/cost/${cost.id}/edit`);
  }

  public setMonth(type: string) {
    if (type === "last") {
      this.params.start_date = moment()
        .add("month", -1)
        .startOf("month")
        .format("YYYY-MM-DD");
      this.params.end_date = moment()
        .add("month", -1)
        .endOf("month")
        .format("YYYY-MM-DD");
    } else if (type === "this") {
      this.params.start_date = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      this.params.end_date = moment()
        .endOf("month")
        .format("YYYY-MM-DD");
    } else if (type === "next") {
      this.params.start_date = moment()
        .add("month", 1)
        .startOf("month")
        .format("YYYY-MM-DD");
      this.params.end_date = moment()
        .add("month", 1)
        .endOf("month")
        .format("YYYY-MM-DD");
    } else if (type == "today") {
      this.params.start_date = moment().format("YYYY-MM-DD");
      this.params.end_date = moment().format("YYYY-MM-DD");
    }
    this.paramsToQuery();
  }

  public csvDownload() {
    this.costExport(this.params);
  }

  public clearEndDate() {
    this.params.end_date = "";
    this.searchFirst();
  }

  public clearStartDate() {
    this.params.start_date = "";
    this.searchFirst();
  }

  public imageClicked(cost: ICost) {
    this.selectedCost = cost;
    this.dialog = true;
  }
}
